// voice.js — late-binding router that selects v2 (legacy MediaRecorder) or
// v3 (Rubidium) when `new Voice(...)` is invoked, NOT at script load.
//
// Late-binding matters because the audio version is configured via USM and
// arrives in the view config, which is fetched by getConfiguration() in
// dispatchpanel.js. That fetch is async, so window.__SCN_AUDIO_VERSION is
// 'v2' (the safe default) at script-load time and may flip to 'v3' before
// any WebRadio is constructed. By resolving the Voice class at instantiation
// time, the right class is picked even though the flag hadn't settled yet
// when this file loaded.
//
// See voice-v2.js (legacy MediaRecorder + decodeAudioData via JS signaling)
// and voice-v3.js (Rubidium IMBE + AES-CTR via TS signaling) for the actual
// implementations. Both files expose themselves as window.VoiceV2 /
// window.VoiceV3 before this file runs (see HTML script load order).

function Voice() {
  var version = (typeof window !== "undefined" && window.__SCN_AUDIO_VERSION) || "v2";
  var Selected;
  if (version === "v3") {
    if (typeof window === "undefined" || typeof window.VoiceV3 !== "function") {
      throw new Error("voice.js: __SCN_AUDIO_VERSION='v3' but window.VoiceV3 is not loaded");
    }
    Selected = window.VoiceV3;
  } else {
    if (typeof window === "undefined" || typeof window.VoiceV2 !== "function") {
      throw new Error("voice.js: __SCN_AUDIO_VERSION='v2' but window.VoiceV2 is not loaded");
    }
    Selected = window.VoiceV2;
  }
  console.info("[VOICE] router selected " + version + " (" + Selected.name + ")");
  return Reflect.construct(Selected, arguments);
}

if (typeof window !== "undefined") { window.Voice = Voice; }
